module.exports = __webpack_public_path__ + "img/photo-04.d8a8b2b2.jpg";